import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { Id } from '@/api/utils/sql';

export type ApiResponse_GetShareableLink = {
  target_type: string;
  target_id: Id;
  metadata: Record<string, unknown>;
  original_url: string;
};

const METHOD = 'GET';
const ENDPOINT = 'negotiation/share/:shortCode';
export const QUERY_KEY = (shortCode: string) =>
  getQueryKey(METHOD, ENDPOINT, { shortCode });

export const useGetShareableLink = (shortCode: string, enabled = true) => useQuery({
  enabled: enabled && !!shortCode,
  queryKey: QUERY_KEY(shortCode),
  queryFn: async () => {
    try {
      // Pass null for session to make this a public API call
      const data = await handleApiCall<ApiResponse_GetShareableLink>(
        null,
        METHOD,
        getResolvedEndpoint(ENDPOINT, { shortCode }),
        undefined
      );

      return data;
    } catch (err) {
      enqueueSnackbar('Failed to fetch shareable link.', { variant: 'error' });
      // Error already handled by enqueueSnackbar
      throw err;
    }
  },
});